import dayjs from 'dayjs';

export const formatDate = (d) => {
  if (!d) return '—';
  const dt = (d instanceof Date) ? d : dayjs(d);
  return dt.isValid ? dayjs(dt).format('DD/MM/YYYY HH:mm') : '—';
};

export const extractEmailName = (arr = []) => {
  if (!Array.isArray(arr) || arr.length === 0) return 'Unknown';
  const first = arr[0];
  if (first.name) return first.name;
  if (first.email) return first.email.split('@')[0];
  return 'Unknown';
};

export const isUnread = (flags = []) => !Array.isArray(flags) ? false : !flags.includes('\\Seen');
